import { useMemo } from "react";
import { toast } from "sonner";
import { trpc } from "@/lib/trpc";

/** Estrelas da pessoa: `procedimento` (Agenda) ou `protese` (serviço do laboratório). Alterna na
 *  hora (otimista) e confirma com o servidor. */
export function useFavoritos(tipo: "procedimento" | "protese", ativo = true) {
  const utils = trpc.useUtils();
  const lista = trpc.favorito.listar.useQuery(undefined, { enabled: ativo, staleTime: 5 * 60_000 });
  const ids = useMemo(
    () => new Set((tipo === "procedimento" ? lista.data?.procedimentos : lista.data?.servicosDeProtese) ?? []),
    [lista.data, tipo],
  );
  const alternar = trpc.favorito.alternar.useMutation({
    onMutate: async ({ id }) => {
      await utils.favorito.listar.cancel();
      const antes = utils.favorito.listar.getData();
      if (antes) {
        const chave = tipo === "procedimento" ? "procedimentos" : "servicosDeProtese";
        const atual = antes[chave];
        utils.favorito.listar.setData(undefined, {
          ...antes,
          [chave]: atual.includes(id) ? atual.filter((x) => x !== id) : [...atual, id],
        });
      }
      return { antes };
    },
    onError: (e, _v, c) => {
      if (c?.antes) utils.favorito.listar.setData(undefined, c.antes);
      toast.error(e.message);
    },
    onSettled: () => utils.favorito.listar.invalidate(),
  });
  return { ids, alternar: (id: string) => alternar.mutate({ tipo, id }) };
}
